import { setSessionContinuityCheck } from '@gov-nx/store/auth/sessionContinuityRegistry';
import { hasPreviousSessionEnded } from '@gov-nx/web/TabTracking/sessionContinuity';

// Must run before the auth store is created, so its rehydration can tell a
// continuing tab from a session whose last tab was closed.
export const registerSessionContinuity = (): void =>
	setSessionContinuityCheck(hasPreviousSessionEnded);
